import { generateBFFUrl, SERVICEABLE_PINCODE } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';

export const updateServiceLocation = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.patch(generateBFFUrl(SERVICEABLE_PINCODE), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
